import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoint('sm')`
      flex-direction: row;
  `}
`;

const SkeletonColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${theme.spacings[5].rem} ${theme.spacings[7].rem};

  ${breakpoint('sm')`      
      & + & {
      border-left: 1px solid ${theme.colors.neutrals.solidGrays[8]};
    }
  `}
`;

const SkeletonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacings[2].rem};

  & > * {
    flex-grow: 1;
  }
`;

export const SearchBoxSkeleton = (
  <SkeletonTheme
    baseColor={theme.colors.neutrals.solidGrays[7]}
    highlightColor={theme.colors.neutrals.solidGrays[8]}
    borderRadius={0}
  >
    <Container>
      <SkeletonColumn style={{ flex: 1 }}>
        <Skeleton
          style={{ marginBottom: theme.spacings[4].px }}
          height={10}
          count={0.5}
        />
        <Skeleton
          style={{
            marginLeft: theme.spacings[2].px,
            marginBottom: theme.spacings[4].px,
          }}
          height={8}
          count={3}
        />
        <Skeleton
          style={{
            marginTop: theme.spacings[4].px,
            marginBottom: theme.spacings[4].px,
          }}
          height={10}
          count={0.5}
        />
        <Skeleton
          style={{
            marginLeft: theme.spacings[2].px,
            marginBottom: theme.spacings[3].px,
          }}
          height={8}
          count={2}
        />
      </SkeletonColumn>
      <SkeletonColumn style={{ flex: 3 }}>
        <Skeleton
          style={{ marginBottom: theme.spacings[4].px }}
          height={20}
          count={0.5}
        />
        <SkeletonBox>
          <Skeleton
            style={{ marginBottom: theme.spacings[3].px }}
            height={260}
            count={1}
          />
          <Skeleton
            style={{ marginBottom: theme.spacings[3].px }}
            height={260}
            count={1}
          />
          <Skeleton
            style={{ marginBottom: theme.spacings[3].px }}
            height={260}
            count={1}
          />
          <Skeleton
            style={{ marginBottom: theme.spacings[3].px }}
            height={260}
            count={1}
          />
        </SkeletonBox>
      </SkeletonColumn>
    </Container>
  </SkeletonTheme>
);
